import React, { useState, useEffect } from 'react';
import { postData, getData } from "../../servicos/api";
import { isAdmin } from "../../servicos/auth";
import * as Yup from 'yup';
import { FormGroup, Label, Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalResponse from '../../Components/ModalResponse';
import Combobox from '../../Components/Combobox';
import { Link } from "react-router-dom";

import { Formik, Form } from 'formik';

//REDUX
import { setLoaderShow, setResponseModal } from '../../reducers/index';
import { connect } from 'react-redux';

import { useQuery } from 'react-query';

const Formulario = (props) => {
    let estabelecimento;
    if (props.data && props.data.estabelecimento_id !== undefined && props.data.estabelecimento_id !== null && props.listaEstabelecimentos.length > 0) {
        estabelecimento = props.listaEstabelecimentos.filter(function (elem, i, object) {
            return elem.value === props.data.estabelecimento_id;
        });
        if (estabelecimento[0] !== undefined) {
            estabelecimento = { value: estabelecimento[0].value, label: estabelecimento[0].label };
        }
    }

    let cliente;
    if (props.data && props.data.cliente_id !== undefined && props.data.cliente_id !== null && props.listaClientes.length > 0) {
        cliente = props.listaClientes.filter(function (elem, i, object) {
            return elem.value === props.data.cliente_id;
        });
        if(cliente[0] !== undefined){
            cliente = { value: cliente[0].value, label: cliente[0].label };
        }
    }

    let validarAdmin = Yup.object({
        estabelecimento_id: Yup.object()
            .required('O campo estabelecimento é obrigatório.'),
        cliente_id: Yup.object()
            .required('O campo cliente é obrigatório.')
    });

    let validarEstabelecimento = Yup.object({
        cliente_id: Yup.object()
            .required('O campo cliente é obrigatório.')
    });

    return (
        <Formik
            initialValues={{
                estabelecimento_id: estabelecimento,
                cliente_id: cliente,
                categoria_cliente_id: props.data.id,
            }}
            enableReinitialize={true}
            dirty={false}
            validationSchema={isAdmin() ? validarAdmin : validarEstabelecimento}
            onSubmit= { values => {

                let data = {
                    "estabelecimento_id": values.estabelecimento_id || (isAdmin()) ? values.estabelecimento_id.value : null,
                    "cliente_id": values.cliente_id ? values.cliente_id.value : null,
                    "categoria_cliente_id": values.categoria_cliente_id
                }

                props.insertCategoriaClienteCliente(data);
            }}
            >
            { formik => (
                <>
                    <Form className="forms-sample col-12" onSubmit={formik.handleSubmit}>
                        <Card>
                            <CardHeader className="bg-maskats text-center">
                                <h4 className="headerTitle">Cadastro de clientes na categoria {props.data.nome}</h4>
                            </CardHeader>
                            <CardBody>
                                <div>

                                    {
                                        isAdmin() ?
                                            <FormGroup>
                                                <Label for="estabelecimento_id">* Estabelecimento</Label>
                                                <Combobox
                                                    invalid={formik.touched.estabelecimento_id && formik.errors.estabelecimento_id}
                                                    valid={formik.touched.estabelecimento_id && !formik.errors.estabelecimento_id}
                                                    id="estabelecimento_id"
                                                    name="estabelecimento_id"
                                                    placeholder={'Selecione um item'}
                                                    defaultValue={formik.values.estabelecimento_id}
                                                    value={formik.values.estabelecimento_id}
                                                    options={props.listaEstabelecimentos}
                                                    isMulti={false}
                                                    loadingMessage={"Carregando..."}
                                                    noOptionsMessage={"Não existem dados cadastrados."}
                                                    onChange={formik.setFieldValue}
                                                    onBlur={formik.setFieldTouched}
                                                    maxMenuHeight={190}
                                                />
                                                {formik.touched.estabelecimento_id && formik.errors.estabelecimento_id ? (
                                                    <div className="divError">{formik.errors.estabelecimento_id}</div>
                                                ) : null}
                                            </FormGroup>
                                            : ""
                                    }

                                    <FormGroup>
                                        <Label for="cliente_id">* Cliente</Label>
                                        <Combobox
                                            invalid={formik.touched.cliente_id && formik.errors.cliente_id}
                                            valid={formik.touched.cliente_id && !formik.errors.cliente_id}
                                            id="cliente_id"
                                            name="cliente_id"
                                            placeholder={'Selecione um item'}
                                            defaultValue={formik.values.cliente_id}
                                            value={formik.values.cliente_id}
                                            options={props.listaClientes}
                                            isMulti={false}
                                            loadingMessage={"Carregando..."}
                                            noOptionsMessage={"Não existem dados cadastrados."}
                                            onChange={formik.setFieldValue}
                                            onBlur={formik.setFieldTouched}
                                            maxMenuHeight={190}
                                        />
                                        {formik.touched.cliente_id && formik.errors.cliente_id ? (
                                            <div className="divError">{formik.errors.cliente_id}</div>
                                        ) : null}
                                    </FormGroup>

                                </div>
                            </CardBody>
                            <CardFooter className="text-align-end bg-white">
                                <Link replace
                                    className='primary'
                                    to={{
                                        pathname: '/categoria-cliente/cliente',
                                        data: props.data
                                    }}>
                                    <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                                        <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                                        <span className="label-button btn-fs-def">Cancelar</span>
                                    </Button>
                                </Link>

                                <Button className="btn text-white btn-sm btn-warning btn-fw bd-rd-8" type="submit">
                                    <i className="fa fa-check btn-icon-append btn-fs-def"></i>
                                    <span className="label-button btn-fs-def">Salvar</span>
                                </Button>
                            </CardFooter>
                        </Card>
                    </Form>
                </>
            )}
        </Formik>
    );
}

function CategoriaClienteClienteFormulario(props) {
    const [listaClientes, setListaClientes] = useState([]);
    const [listaEstabelecimentos, setListaEstabelecimentos] = useState([]);

    const staleTime = 1000 * 60 * 60;

    const estabelecimentosQuery = useQuery('estabelecimentos', () => getData(`/estabelecimento`, props), { staleTime });
    const clientesQuery = useQuery('clientes', () => getData(`/cliente`, props), { staleTime });

    const insertCategoriaClienteCliente = async (data) => {
        loadingShow(true);
        await postData(`/categoria-cliente/cliente`, props, data, '/categoria-cliente/cliente/', true);
        loadingShow(false);
    }

    function loadingShow(value) {
        let { setLoaderShow } = props;
        setLoaderShow(value);
    }

    useEffect(() => {
        loadingShow(true);
    }, []);

    useEffect(() => {

        if (estabelecimentosQuery.isSuccess && estabelecimentosQuery.data) {
            const mappedEstabelecimentos = estabelecimentosQuery.data.map(value => ({
                value: value.id,
                label: value.nome,
                ativo: value.ativo
            }));
            setListaEstabelecimentos(mappedEstabelecimentos);
        }

        if (clientesQuery.isSuccess && clientesQuery.data) {
            const mappedClientes = clientesQuery.data.map(value => ({
                value: value.id,
                label: value.nome,
                celular: value.telefone_principal,
                ativo: value.ativo
            }));
            setListaClientes(mappedClientes);
        }

        if ( estabelecimentosQuery.isSuccess && clientesQuery.isSuccess ) {
            loadingShow(false);
        }

    }, [
        estabelecimentosQuery.isSuccess,
        estabelecimentosQuery.data,
        clientesQuery.isSuccess,
        clientesQuery.data,
    ]);

    const { data } = props.location;
    const { setResponseModal, enableResponseModal } = props;

    return (
        <>
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 grid-margin stretch-card">
                                    <Formulario
                                        data={data}
                                        insertCategoriaClienteCliente={insertCategoriaClienteCliente}
                                        listaEstabelecimentos={listaEstabelecimentos}
                                        listaClientes={listaClientes}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalResponse
                history={props.history}
                setResponseModal={setResponseModal}
                enableResponseModal={enableResponseModal}
            />
        </>
    );
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriaClienteClienteFormulario);